export default __webpack_public_path__ + "a5e34ea3d4e37febfb5d35fb9a853a90.png";